import React from 'react';
import { cn } from '../../utils/cn';
import { Card } from './Card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface KPICardProps {
  title: string;
  value: string | number;
  trend?: {
    value: number;
    direction: 'up' | 'down';
    label?: string;
  };
  subValue?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  alertLevel?: 'none' | 'warning' | 'critical';
}
export function KPICard({
  title,
  value,
  trend,
  subValue,
  icon,
  className,
  alertLevel = 'none'
}: KPICardProps) {
  return <Card className={cn('relative overflow-hidden transition-all', className)} data-id="element-392">
      {alertLevel === 'warning' && <div className="absolute inset-0 border-2 border-amber-500/50 rounded-lg pointer-events-none animate-pulse" data-id="element-393" />}
      {alertLevel === 'critical' && <div className="absolute inset-0 border-2 border-red-500/50 rounded-lg pointer-events-none animate-pulse" data-id="element-394" />}

      <div className="flex justify-between items-start mb-2" data-id="element-395">
        <h3 className="text-sm font-medium text-gray-400" data-id="element-396">{title}</h3>
        {icon && <div className="text-gray-500" data-id="element-397">{icon}</div>}
      </div>

      <div className="flex items-baseline gap-2" data-id="element-398">
        <span className="text-3xl font-bold text-white tracking-tight" data-id="element-399">
          {value}
        </span>
        {trend && <div className={cn('flex items-center text-xs font-medium', trend.direction === 'up' ? 'text-emerald-500' : 'text-red-500')} data-id="element-400">
            {trend.direction === 'up' ? <ArrowUpRight className="h-3 w-3 mr-0.5" data-id="element-401" /> : <ArrowDownRight className="h-3 w-3 mr-0.5" data-id="element-402" />}
            {Math.abs(trend.value)}%
          </div>}
      </div>

      {subValue && <div className="mt-3 pt-3 border-t border-gray-800/50" data-id="element-403">{subValue}</div>}
    </Card>;
}